import React from "react"
import styled, { useTheme } from '~/ui/styled'
import { Flex, IconFont } from "~components/El"
import { presets } from "../message/palette"
import { ReplyComponent } from "~components/message/message"

const ReplyBarWrap = styled(Flex)`
  width: 100%;
  height: auto;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  padding: ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.lg};
`
const ReplyBarBox = styled(Flex)`
  width: 100%;
  padding-left: ${({ theme }) => theme.space.sm};
  border-left: 2px solid ${({ theme }) => theme.colors.primary};
  flex-direction: row;
  justify-content: space-between;
`
const ReplyBarBoxTitle = styled.Text`
  color: ${({ theme }) => theme.colors.primary};
`
const ReplayBarBoxLeftWrap = styled(Flex)`
  width: 40%;
  align-items: flex-start;
  justify-content: space-between;
`
const ReplayBarBoxRightWrap = styled(Flex)`
width: auto;
height: auto;
`
const ReplayBarBoxCloseIconWrap = styled(Flex)`
width: auto;
height: auto;
`

const ReplyBar = ({ message, setIsReplyBarVisible }) => {
  const palette = presets.grey
const theme = useTheme()
  const handleOnClose = () => {
    setIsReplyBarVisible(false)
  }
  return (
    <ReplyBarWrap>
      <ReplyBarBox>
        <ReplayBarBoxLeftWrap>
          <ReplyBarBoxTitle>{message.sender.name}</ReplyBarBoxTitle>
          <ReplyComponent message={message} color={palette.text} isGroup={false} />
        </ReplayBarBoxLeftWrap>
        <ReplayBarBoxRightWrap>
          <ReplayBarBoxCloseIconWrap onClick={handleOnClose}>
            <IconFont name="close" size={18} color={theme.colors.secondaryText}></IconFont>
          </ReplayBarBoxCloseIconWrap>
        </ReplayBarBoxRightWrap>
      </ReplyBarBox>
    </ReplyBarWrap>
  )
}

export default ReplyBar
